export type EducationLevel =
  | "10th_below"
  | "12th_pass"
  | "diploma"
  | "iti"
  | "graduate"
  | "post_grad";

export type DegreeType =
  | "ba"
  | "bcom"
  | "bsc"
  | "btech"
  | "bba"
  | "bca"
  | "ma"
  | "mcom"
  | "msc"
  | "mtech"
  | "mba"
  | "mca"
  | "phd"
  | "diploma_cert"
  | "other";

export const EDUCATION_LEVEL_OPTIONS = [
  { label: "10th or Below", value: "10th_below" },
  { label: "12th Pass", value: "12th_pass" },
  { label: "Diploma", value: "diploma" },
  { label: "ITI", value: "iti" },
  { label: "Graduate", value: "graduate" },
  { label: "Post Graduate", value: "post_grad" },
] as const satisfies readonly { label: string; value: EducationLevel }[];

export const JOB_EDUCATION_LEVEL_OPTIONS = [
  { label: "10th or Below", value: "10th_below" },
  { label: "12th Pass", value: "12th_pass" },
  { label: "Diploma / ITI", value: "diploma" },
  { label: "Graduate", value: "graduate" },
  { label: "Post Graduate", value: "post_grad" },
] as const;

export const DEGREE_OPTIONS = [
  { value: "ba", label: "B.A." },
  { value: "bcom", label: "B.Com" },
  { value: "bsc", label: "B.Sc." },
  { value: "btech", label: "B.Tech / B.E." },
  { value: "bba", label: "BBA" },
  { value: "bca", label: "BCA" },
  { value: "ma", label: "M.A." },
  { value: "mcom", label: "M.Com" },
  { value: "msc", label: "M.Sc." },
  { value: "mtech", label: "M.Tech / M.E." },
  { value: "mba", label: "MBA" },
  { value: "mca", label: "MCA" },
  { value: "phd", label: "PhD" },
  { value: "diploma_cert", label: "Diploma" },
  { value: "other", label: "Other" },
] as const satisfies readonly { value: DegreeType; label: string }[];

export function educationLevelLabel(value: string | null | undefined): string {
  return EDUCATION_LEVEL_OPTIONS.find((opt) => opt.value === value)?.label
    ?? JOB_EDUCATION_LEVEL_OPTIONS.find((opt) => opt.value === value)?.label
    ?? "";
}

export function degreeLabel(value: string | null | undefined): string {
  return DEGREE_OPTIONS.find((opt) => opt.value === value)?.label ?? "";
}

export function buildEducationSummary(values: {
  education_level?: string | null;
  degree?: string | null;
  specialization?: string | null;
  college_name?: string | null;
  graduation_year?: number | null;
}): string {
  const parts = [
    educationLevelLabel(values.education_level),
    degreeLabel(values.degree),
    values.specialization ? `in ${values.specialization}` : "",
    values.college_name?.trim() ?? "",
    values.graduation_year ? `(${values.graduation_year})` : "",
  ].filter(Boolean);
  return parts.join(" — ");
}

export function isGraduateLevel(level: string | null | undefined): boolean {
  return level === "graduate" || level === "post_grad";
}
